module.exports = __webpack_public_path__ + "img/1.31d2c0fd.png";